export const formatPercent = (val: any, aboveScale?: boolean, digits = 2) => {
  if (!!val && val[val.length - 1] === '%') return val;
  if (val > 100 && !aboveScale) {
    return new Intl.NumberFormat('us-US', {
      style: 'percent',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(100 / 100);
  }
  return new Intl.NumberFormat('us-US', {
    style: 'percent',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(val / 100);
};

export const unFormatPercent = (val: any) => {
  if (!val) return 0;
  if (typeof val === 'number')
    return `${val}`.replace(/,/g, '').replace('%', '');
  return val.replace(/,/g, '').replace('%', '');
};
